import React, {useState, useContext /*, useEffect*/} from 'react';

import Header from './Header.js';
import Disclaimers from './Disclaimers.js';
//import ConfirmDialog from './ConfirmDialog.js';
import ConfirmLoginState from './ConfirmLoginState.js';
import SleepLogHistory from './SleepLogHistory.js';

import { makeStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
//import Link from '@material-ui/core/Link';
//import CardMedia from '@material-ui/core/CardMedia'
//import CircularProgress from "@material-ui/core/CircularProgress";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemText from '@material-ui/core/ListItemText';
import Snackbar from '@material-ui/core/Snackbar';

import firebase, {firestore, auth, signInWithGoogle} from './firebase.js'
import {UserContext} from './UserContext.js';
//import {useCollection} from 'react-firebase-hooks/firestore'

//import google_button from './btn_google_signin_dark_normal_web.png';


const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
        padding: 20,
        paddingTop:100,
        margin: 'auto',
      maxWidth: 800,
    },
    formCard: {
      padding: theme.spacing(2),
      textAlign: 'left',
      color: theme.palette.text.secondary,
        //margin: theme.spacing(2),
        alignItems: 'center',
    },
    card: {
        //padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
          //margin: theme.spacing(2),
          alignItems: 'center',
      }, 
      button: {
           padding: theme.spacing(2),
        margin: theme.spacing(1),
          alignItems: 'center',
          //width: 150,
      },
      cardContent: {
          paddingTop: theme.spacing(1),
          paddintBottom: theme.spacing(1),
          paddingRight: theme.spacing(1),
          paddingLeft: theme.spacing(1),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        marginLeft: theme.spacing(0),
        marginRight: theme.spacing(0),
      },
      cardAction: {
        justifyContent: 'center',  
        alignItems: 'center',
         paddingTop: theme.spacing(1),
          paddingBottom: theme.spacing(1),
          paddingRight: theme.spacing(1),
          paddingLeft: theme.spacing(1),
        margin: theme.spacing(0),
      },
      cardActionForm: {
        justifyContent: 'left', 
        //display:'flex',
        //flexGrow:1, 
         paddingTop: theme.spacing(1),
          paddingBottom: theme.spacing(1),
          paddingRight: theme.spacing(1),
          paddingLeft: theme.spacing(1),
        margin: theme.spacing(0),
      },
      cardActionButton: {
        justifyContent: 'center',  
        alignItems: 'center',
         paddingTop: theme.spacing(0),
          paddingBottom: theme.spacing(1),
          paddingRight: theme.spacing(1),
          paddingLeft: theme.spacing(1),
        margin: theme.spacing(0),
      },
      media: {
          //width: 100,
          //marginBottom: theme.spacing(4),
      },
      textField: {
          //textAlign: 'right',
          //marginRight:theme.spacing(1),
      },
      textForm: {
        textAlign: "left",
        //flexGrow: 1,
        //marginLeft:theme.spacing(1),
        //padding: theme.spacing(2),
        //margin: theme.spacing(2),
      },
      textList: {
        textAlign: "right",
      },
      text: {
        textAlign: "center",
        //padding: theme.spacing(2),
        //margin: theme.spacing(2),
      },
      textExplanation: {
        textAlign: "justify",
        //padding: theme.spacing(2),
        //margin: theme.spacing(2),
      },
      select: {
        minWidth: 250,
      }
  }));

  // SLEEP CONTENTMENT CONST
  const defaultQualityOptions = ["0 - Very Poor", "1 - Poor", "2 - Decent", "3 - Good", "4 -Very good"];

export default function SleepLog (props) {
    const {user, loading, error}= useContext(UserContext);
    const [bedTime, setBedTime] = useState(null);
    const [lightsOut, setLightsOut] = useState(null);
    const [awake, setAwake] = useState(null);
    const [latency, setLatency] = useState(0);
    const [awakeningsInBed, setAwakeningsInBed] = useState(0); //Awakenigns In Bed
    const [awakeningsOutOfBed, setAwakeningsOutOfBed] = useState(0); //Awakenings Out Of Bed
    const [comments, setComments] = useState("");
    const [sleepQuality, setSleepQuality] = useState(2); // Set to "decent" (see defaultContentmentScore for options)
    //const [dataSaved, setDataSaved] = useState(false);
    const [showDataSaved, setShowDataSaved] = useState(false);
    

    // No longer display data saved when user starts filling again
    /*
    useEffect(()=> {
        if (!bedTime) {
            //setDataSaved(false); 
        }
    }
    , [bedTime]); */

    const totalTimeInBed = () => { 
        if (bedTime && awake) {
            const bedTimeToAwakeTimeMin = Math.abs(bedTime.getTime()-awake.getTime())/60000; //in minutes
            return ((bedTimeToAwakeTimeMin-awakeningsOutOfBed)/60).toFixed(2);

        } 
        return 0;
    };

    const timeAwakeInBed = () => {
        //return (latency/60 + awakeningsInBed/60).toFixed(2);
        if (bedTime && awake && lightsOut) {
            const timeToLightsOut = Math.abs(bedTime.getTime()-lightsOut.getTime())/60000; //in minutes
            return (timeToLightsOut/60 + latency/60 + awakeningsOutOfBed/60).toFixed(2); //in hours
        }
        return 0;
    }

    const totalSleepTime = () => { 
        if (bedTime && awake && lightsOut) {
            return (totalTimeInBed()-timeAwakeInBed()).toFixed(2);

        } 
        return 0;
    };

    const sleepEfficiency = () => {
        if (bedTime && awake && lightsOut) {
            const efficiency = (totalSleepTime()/totalTimeInBed())*100;
            return (Number.isNaN(efficiency) ? "" : efficiency.toFixed(2)); // Keep blank if NaN

        } 
        return "";
    }

    // TODO: Find way to display as time (08 H:08 MIN)
    /*const displayTime = (hours) => {
        const minutes = (hours - Math.floor(hours))*60;
        return `${Math.floor(hours)} : ${minutes.toFixed(0)}`;
    } */

    const classes = useStyles();

    // Manage Log Data
    function fixTimeZone(date) { // FIX JSON TIME USING TIMEZONE
        date.setMinutes(date.getMinutes()-date.getTimezoneOffset());
        return date;
    }

    /*
    function returnTimeZone(date) { // ADD TIMEZONE BACK IN FOR UPLOAD
        date.setMinutes(date.getMinutes()+date.getTimezoneOffset());
        return date;
    } */

    function handleBedTimeValueChange(event) {
        //const date = fixTimeZone(new Date(event.target.value));
        const date = new Date(event.target.value);
        setBedTime(date);
        //console.log("Bedtime: " + returnTimeZone(date).toString()); // Force time zone back in

        // Fix Lights Out If Needed Because BedTime Is Now Later Than Original Lights Out
        if (lightsOut) { //If lightsOut is NOT null
            const timeIntervalBedTimeLightsOut = lightsOut.getTime() - date.getTime();

            if (timeIntervalBedTimeLightsOut < 0) { // Only update if lights out is >= bedTime
                setLightsOut(date);
            } 
        } else { //lights out is null, fill in
            setLightsOut(date);
        }

        // If awake present, make sure it is at least wake time
        if (awake) {
            const timeIntervalBedtimeAwake = awake.getTime() - date.getTime();

            if (timeIntervalBedtimeAwake < 0) {
                setAwake(date);
            }
        } else { //awake is null, fill in
            setAwake(date);
        } 
       
    }

    function handleLightsOutValueChange(event) {
        //const date = fixTimeZone(new Date(event.target.value));
        const date = new Date(event.target.value);
        setLightsOut(date);
   
        // Fix Lights Out If Needed Comapred to Bedtime
        if (bedTime) { // If bedtime is NOT null
            const timeIntervalBedTimeLightsOut = date.getTime() - bedTime.getTime();

            if (timeIntervalBedTimeLightsOut < 0) { // Only update if lights out is >= bedTime
                setLightsOut(bedTime);
            } 
        } else { //If bedtime is null, update
            setBedTime(date);
        }
        
        // If awake present, make suire it is at least lights out time
        if (awake) {
            const timeIntervalLightsOutAwake = awake.getTime() - date.getTime();

            if (timeIntervalLightsOutAwake < 0) {
                setAwake(date);
            }
        } else {
            setAwake(date);
        }
    }

    function handleAwakeValueChange(event) {
        //const date = fixTimeZone(new Date(event.target.value));
        const date = new Date(event.target.value);
        setAwake(date);

        // Fix Lights Out If Needed Comapred to Bedtime
        if (lightsOut) { // If lightOut is NOT null
            const timeIntervalBedTImeLightsOut = date.getTime() - lightsOut.getTime();

            if (timeIntervalBedTImeLightsOut < 0) { // Only update if lights out is >= bedTime
                setAwake(lightsOut);
            } 
        } else { //If lgihts out is null, update
            setLightsOut(date);
        } 

        if (!bedTime) { //if bedtime is also nulll, update
            setBedTime(date);
        } 
    }

    function handleLatencyValueChange(event) {
        setLatency(event.target.value);
    }

    function handleawakeningsInBedValueChange(event) {
        setAwakeningsInBed(event.target.value);
    }

    function handleawakeningsOutOfBedChange(event) {
        setAwakeningsOutOfBed(event.target.value);
    }

    function handleCommentsValueChange(event) {
        setComments(event.target.value);
    }

    function handleSleepQualitySelect(event) {
        setSleepQuality(event.target.value);
    }

    // Manage Logins
      const googleSignIn = () => {
        //event.preventDefault();
        signInWithGoogle();
      }

      const signOut = (event) => {
          event.preventDefault();
          auth.signOut();
      }

    /// Manage Data
    const handleSaveSubmit = (event) => {
        event.preventDefault();
        firestore.collection("Users")
       .doc(user.uid)
       .collection("sleep-logs")
       .doc(new Date(bedTime).toString())
       .set({
           bedtime: firebase.firestore.Timestamp.fromDate(new Date(bedTime)), 
           lightsOut: firebase.firestore.Timestamp.fromDate(new Date(lightsOut)),
           awake: firebase.firestore.Timestamp.fromDate(new Date(awake)),
           latency: Number(latency),
           awakeningsInBed: Number(awakeningsInBed),
           awakeningsOutOfBed: Number(awakeningsOutOfBed),
           comments: comments,
           sleepQuality: Number(sleepQuality),
           totalTimeInBed: Number(totalTimeInBed()),
           timeAwakeInBed: Number(timeAwakeInBed()),
           totalSleepTime: Number(totalSleepTime()),
           sleepEfficiency: Number(sleepEfficiency()),
       })
        .then(() => {
            console.log("Uploaded Data");
            //setDataSaved(true);
            setShowDataSaved(true);
            handleResetClick(); //Reset when uploaded
        });
    }    

    const handleResetClick = () => {
        setBedTime(null);
        setLightsOut(null);
        setAwake(null);
        setLatency(0);
        setAwakeningsInBed(0);
        setAwakeningsOutOfBed(0);
        setSleepQuality(2);
        setComments("");
    }

    const handleDataSavedClose  = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        if (event) {
          event.preventDefault();
        };
        setShowDataSaved(false);  
      };


    return <>
            <div className={classes.root}>
                <Header title={"Sleep Log"} subTitle={"Track Your Sleep Schedule"} />
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Card className={classes.formCard}>
                            <CardContent className={classes.cardContent}>
                                <Typography className={classes.textExplanation} color="inherit" variant="h4"><strong>Today's Log</strong></Typography>
                                <Typography className={classes.textExplanation} color="inherit">Update the information below to calculate your sleep data, such as sleep efficiency.</Typography>
                            </CardContent>
                            <form onSubmit={handleSaveSubmit}>
                                <CardActions className={classes.cardActionForm}> 
                                    <TextField className={classes.textField} fullWidth variant="outlined" id="bedtime" label="Bedtime (Time Got In Bed)" type="datetime-local" InputLabelProps={{shrink: true,}} value={bedTime ? fixTimeZone(new Date(bedTime)).toJSON().substring(0,16): ""} onChange={handleBedTimeValueChange}/>
                                </CardActions>
                                <CardActions className={classes.cardActionForm}> 
                                    <TextField className={classes.textField} fullWidth variant="outlined" id="lightsout" label="Lights Out (Time Try To Go To Sleep)" type="datetime-local" InputLabelProps={{shrink: true,}}  value={lightsOut ? fixTimeZone(new Date(lightsOut)).toJSON().substring(0,16): ""} onChange={handleLightsOutValueChange}/>
                                </CardActions>
                                <CardActions className={classes.cardActionForm}> 
                                    <TextField className={classes.textField} fullWidth variant="outlined" id="latency" label="Time To Fall Asleep" type="number" InputLabelProps={{shrink: true,}} value={latency} onChange={handleLatencyValueChange}/>min
                                </CardActions>
                                <CardActions className={classes.cardActionForm}>
                                    <TextField className={classes.textField} fullWidth variant="outlined" id="awake-night" label="Nightime Awakenings (In Bed)" type="number" InputLabelProps={{shrink: true,}} value={awakeningsInBed} onChange={handleawakeningsInBedValueChange} />min
                                </CardActions>
                                <CardActions className={classes.cardActionForm}>
                                    <TextField className={classes.textField} fullWidth variant="outlined" id="out-of-bed" label="Nightime Awakenings (Out Of Bed)" type="number" InputLabelProps={{shrink: true,}} value={awakeningsOutOfBed} onChange={handleawakeningsOutOfBedChange} />min
                                </CardActions>
                                <CardActions className={classes.cardActionForm}> 
                                    <TextField className={classes.textField} fullWidth variant="outlined" id="awake-date" label="Awake (Time Out Of Bed For The Day)" type="datetime-local" InputLabelProps={{shrink: true,}} value={awake ? fixTimeZone(new Date(awake)).toJSON().substring(0,16): ""} onChange={handleAwakeValueChange}/>
                                </CardActions>
                                <CardActions className={classes.cardActionForm}> 
                                    <TextField className={classes.textField} fullWidth variant="outlined" id="comments" label="Comments" type="text" InputLabelProps={{shrink: true,}} value={comments} onChange={handleCommentsValueChange}/>
                                </CardActions>
                                <CardActions className={classes.cardActionForm}>
                                    <FormControl fullWidth>
                                        <InputLabel htmlFor="sleep-quality">Sleep Quality:</InputLabel>
                                        <Select id="sleep-quality" value={sleepQuality} onChange={handleSleepQualitySelect}>
                                                {defaultQualityOptions.map((option, index)=><MenuItem value={index} key={option}>{option}</MenuItem>)}
                                        </Select>
                                    </FormControl>
                                </CardActions><br/><br/>
                                <Divider />
                                <CardContent className={classes.cardContent}>
                                 <Typography className={classes.textPlanation} variant="h4"><strong>Results</strong></Typography>
                                 <Typography className={classes.textExplanation} color="inherit">Relevant calculations of today's sleep quality.</Typography>
                                <List>
                                    <ListItem alignItems='flex-start'>
                                        <ListItemText><Typography className={classes.textExplanation} variant="h6">Time In Bed:</Typography></ListItemText>
                                        <ListItemText><Typography className={classes.textList} variant="body1">{totalTimeInBed()} Hours</Typography></ListItemText>
                                    </ListItem>
                                    <Divider />
                                    <ListItem alignItems='flex-start'>
                                        <ListItemText><Typography className={classes.textExplanation} variant="h6">Time Awake In Bed:</Typography></ListItemText>
                                        <ListItemText><Typography className={classes.textList} variant="body1">{timeAwakeInBed()} Hours</Typography></ListItemText>
                                    </ListItem>
                                    <Divider />
                                    <ListItem alignItems='flex-start'>
                                        <ListItemText><Typography className={classes.textExplanation} variant="h6">Total Sleep Time:</Typography></ListItemText>
                                        <ListItemText><Typography className={classes.textList} variant="body1">{totalSleepTime()} Hours</Typography></ListItemText>
                                    </ListItem>
                                    <Divider />
                                    <ListItem alignItems='flex-start'>
                                        <ListItemText><Typography className={classes.textExplanation} variant="h6">Sleep Effiency:</Typography></ListItemText>
                                        <ListItemText><Typography className={classes.textList} variant="body1">{sleepEfficiency()}%</Typography></ListItemText>
                                    </ListItem>
                                    <Divider />
                                </List>
                            </CardContent>    
                            <ConfirmLoginState loading={loading} error={error} user={user} onSignIn={googleSignIn} onSignOut={signOut} explanationText={"To be able to save today's sleep log you need to be logged in through your Google account."} displayFragment={(sleepEfficiency() !== "") ? 
                            <>
                            <CardActions className={classes.cardActionButton}>  
                                <Button className={classes.button} variant="contained" color="primary" name="submit" type="submit">Save Today's Log</Button>
                                <Button className={classes.button} variant="contained" color="primary" onClick={handleResetClick}>Reset</Button>
                            </CardActions>
                            </> : <> 
                            <CardActions className={classes.cardActionButton}>
                                <Button className={classes.button} variant="contained" color="primary" name="submit" type="submit" disabled>Complete Log To Save</Button>
                                <Button className={classes.button} variant="contained" color="primary" onClick={handleResetClick}>Reset</Button>
                            </CardActions>
                            </>}/>    
                             </form>          
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card className={classes.formCard}>
                            <CardContent className={classes.cardContent}>
                                <Typography className={classes.textExplanation} color="inherit" variant="h4"><strong>History</strong></Typography>
                                <Typography className={classes.textExplanation} color="inherit">Review past sleep logs.</Typography>
                            </CardContent>
                            <ConfirmLoginState loading={loading} error={error} user={user} onSignIn={googleSignIn} onSignOut={signOut} explanationText={"To be able to view your Sleep Log history, you need to be logged in through your Google account."} displayFragment={<SleepLogHistory user={user} />}/>                
                        </Card>
                    </Grid>
                </Grid>
                <Disclaimers />
                <Snackbar open={showDataSaved} autoHideDuration={3000} onClose={handleDataSavedClose} message="Data saved." action={<Button color="primary" onClick={handleDataSavedClose}>OK</Button>}/>
            </div>
        </>;
}
